import logo from '@/assets/logo.svg';

export function LoadingPage() {
  return (
    <div className="flex flex-col items-center justify-center content-center w-full h-screen gap-4">
      <img src={logo} className="w-auto h-16 animate-pulse" />
      <div className="loading loading-spinner loading-md text-primary"></div>
    </div>
  );
}
